import { Flex, IllustratedMessage, Heading, Content } from '@adobe/react-spectrum';
import { useTranslation } from 'react-i18next';
import NotFound from '@spectrum-icons/illustrations/NotFound';

/**
 * NoResultsMessage Component
 * 
 * Reusable empty state message displayed when no activities are found.
 */
export function NoResultsMessage() {
  const { t } = useTranslation();
  
  return (
    <Flex direction="row" width="100%" alignContent="center" justifyContent="center">
      <IllustratedMessage>
        <NotFound />
        <Heading>{t('no_results', { ns: 'layout_components' })}</Heading>
        <Content>{t('try_another_search', { ns: 'layout_components' })}</Content>
      </IllustratedMessage>
    </Flex>
  );
}

